import styled from 'styled-components';
import { breakpoints } from 'styles/breakpoints';

export const StyledWhispersBalance = styled.div`
  display: inline-flex;
  align-items: center;
  font-weight: 700;
  padding: 2px 7px;
  margin-right: 8px;
  background: #ffe8db;
  border-radius: 16px;
  color: #000000;
  font-size: 14px;
  font-family: 'Sofia Pro', sans-serif;
  height: 100%;

  .balanceImg {
    max-width: 16px;
    max-height: 16px;
    margin-right: 5px;
    background-color: transparent;
  }

  @media (width <= ${breakpoints.mobileL}) {
    font-size: 12px;
  }
`;
